import React from 'react';

// Custom motorbike icon component
export const MotorbikeIcon = ({ size = 20, className = "" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
  >
    <path d="M8 5h8l2 4h1a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1a3 3 0 0 1-3 3 3 3 0 0 1-3-3H7a3 3 0 0 1-3 3 3 3 0 0 1-3-3V7a2 2 0 0 1 2-2h5zm0 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path>
  </svg>
);

// Badge to display invoice source information
export const InvoiceSourceBadge = ({ invoiceNumber }) => {
  return (
    <div className="flex items-center bg-blue-900/40 rounded-full px-3 py-1 text-xs border border-blue-700">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={12} 
        height={12} 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className="text-blue-400 mr-1"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
      </svg>
      <span className="text-blue-200">From Invoice: {invoiceNumber}</span>
    </div>
  );
};